import { z } from 'zod';

export const WorkstreamSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  progress: z.number(),
  startDate: z.date(),
  endDate: z.date(),
  responsible: z.string().optional(),
});

export type Workstream = z.infer<typeof WorkstreamSchema>;
